import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import GoalTrackingDummyRepository from './infrastructure/repositories/goal-tracking-dummy-repository/goal-tracking-dummy-repository';
import GoalTrackingHttpRepository from './infrastructure/repositories/goal-tracking-http-repository';

// Application
import GetGoalTrackingQuery from './application/queries/get-goal-tracking-query';
import SetGoalTrackingCommand from './application/commands/set-goal-tracking-command';

// Domain
import { GoalTrackingRepository } from './domain/repositories/goal-tracking-repository';

export default function setupGoalTracking(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<GoalTrackingRepository>(
      TYPES.GOAL_TRACKING_REPOSITORY,
    ).to(
      withDummies
        ? GoalTrackingDummyRepository
        : GoalTrackingHttpRepository,
    ).inSingletonScope();

  container
    .bind<GetGoalTrackingQuery>(
      TYPES.GET_GOAL_TRACKING_QUERY,
    ).to(GetGoalTrackingQuery)
    .inSingletonScope();

  container
    .bind<SetGoalTrackingCommand>(
      TYPES.SET_GOAL_TRACKING_COMMAND,
    ).to(SetGoalTrackingCommand)
    .inSingletonScope();
}
